import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPaymentType, EmptyString, FormTypeAdd, FormTypeView, MenuPaymentId, MenuPaymentSubConId } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckUserMenuAccess, ApiCreatePaymentSubCon, ApiDeletePaymentSubCon, ApiGetClientListSubCon, ApiGetPaymentByIdSubCon, ApiUpdatePaymentSubCon } from "utils/constants/api";
import { GetPaymentType, GetStatus, money } from "utils/helpers";
import moment from "moment";

export default function PaymentSubConForm(){
    let navigate = useNavigate()
    
    const { fetch: getPaymentById } = useFetch(ApiGetPaymentByIdSubCon)
    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramPaymentId = queryString.get("paymentId")

    const [projectId, setProjectId] = useState(EmptyString)
    const [clientName, setClientName] = useState(EmptyString)
    const [paymentDate, setPaymentDate] = useState(EmptyString)
    const [paymentType, setPaymentType] = useState(EmptyString)
    const [paymentTypeOptions, setPaymentTypeOptions] = useState(DropdownPaymentType)
    const [amount, setAmount] = useState(EmptyString)
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [projectData, setProjectData] = useState([])

    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    const downloadImage = () => {
        if (!fileUrl) return;
      
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = clientName + '_termin' + paymentType + '.jpg'
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const backBtnClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        setLoading({isOpen: true})
        fCheckUserAccess(localStorage.getItem("Id"), MenuPaymentSubConId, localStorage.getItem("CompanyId")).then((res) => {
            if(res.access){
                setPaymentDate(new Date())

                fGetPaymentById(paramPaymentId).then(() => {
                    setLoading({isOpen: false}) 
                })  
            }else{
                navigate("/access-denied")
            }
        })
    }, [])

    // Function Api Call
    async function fGetPaymentById(paramPaymentId){
        await getPaymentById({
            data: {
                paymentId: paramPaymentId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setProjectId(data.projectId)
                setClientName(data.clientName)
                setPaymentDate(data.paymentDate)
                setPaymentType(data.paymentType)
                setAmount(money(data.amount))
                if (data.photoUrl !== null || data.photoUrl !== EmptyString){
                    setFileUrl(data.photoUrl)
                }
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }

    function fGetPaymentTypeList(selectedProjectId){
        let tempArray = []

        if(projectData.length > 0){
            for(let i = 0; projectData.length > i; i++){
                if(projectData[i].projectId == selectedProjectId){
                    let paymentTypeList = projectData[i].paymentType

                    tempArray.push({ label: "Select payment type", value: "" })

                    for (let i = 0; i < paymentTypeList.length; i++){
                        tempArray.push({ label: paymentTypeList[i].value, value: String(paymentTypeList[i].id) })
                    }

                    setPaymentTypeOptions(tempArray)
                    setPaymentType(tempArray[0].value)
                }
            }
        }
        
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Payment Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Client Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Client Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{clientName}</label>
                        </div>
                    </div>
                </div>

                {/* Payment Date */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Payment Date</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{moment(paymentDate).format("DD MMM yyyy")}</label>
                        </div>
                    </div>
                </div>

                {/* Payment Type */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Payment Type</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{GetPaymentType(paymentType)}</label>
                        </div>
                    </div>
                </div>

                {/* Amount */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Amount</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="flex items-center w-full sm:w-72">
                            <label>{"Rp " + amount}</label>
                        </div>
                    </div>
                </div>

                {/* Payment Slip */}
                <div>
                    <div className="flex flex-col sm:flex-row ">
                        <div className="w-48 mt-2">
                            <span>Payment Slip</span>
                        </div>
                        <div className="px-4 hidden sm:block mt-2">
                            <span>:</span>
                        </div>
                        
                        <div className="w-full sm:w-72 flex flex-col gap-2">
                            <img className="w-full h-[180px] object-cover mx-auto border rounded-md" src={fileUrl} alt="ID" />
                            <button
                                onClick={downloadImage}
                                className="w-full h-[50px] bg-blue-500 text-white rounded"
                                >
                                Download Image
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}